var PRIMEControllersUKPDSOM2 = angular.module('PRIMEControllersUKPDSOM2', []).run(function($rootScope) {
	  
})


PRIMEControllersUKPDSOM2.controller("HomeUKPDSOM2", function ($scope) {
	$scope.strings = {
		"title":"Home",
		"welcome":"Welcome to the PRIME Implementation of the UKPDS Outcomes Model 2"
	}
});







// ===============================================
// Cohorts
// ===============================================
PRIMEControllersUKPDSOM2.controller("CohortsUKPDSOM2", ["$scope", "$routeParams", "$location", "$modal", "$controller", "CohortUKPDSOM2", function ($scope, $routeParams, $location, $modal, $controller, CohortUKPDSOM2, NewCohortUKPDSOM2, EditCohortUKPDSOM2) {

	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCohort = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/cohort-new.html",
			controller: "NewCohortUKPDSOM2",
			size: size,
			resolve: {
				cohorts: function () {
					return $scope.cohorts;
				}
			},
		});

		modalInstance.result.then(function (newCohort) {
			newCohort.$save({}, function(data) {
				$scope.cohorts.push(newCohort);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create cohort modal dismissed at: " + new Date());
		});
	}

	$scope.editCohortModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/cohort-new.html",
			controller: "EditCohortModal",
			size: size,
			resolve: {
				cohorts: function () { return $scope.cohorts; },
				cohortId: function() { return id; },
				readOnly: function() { return false; }
			}
		});

		modalInstance.result.then(function (editedCohort) {
			editedCohort.$update({}, function(data) {
				$scope.cohorts.filter(function(cohort, index, cohorts) {
					if (cohort._id === data._id) {
						cohorts[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit cohort modal dismissed at: " + new Date());
		});
		
	}
	
	
	
	$scope.strings = {
		"title":"UKPDS OM2 Cohorts",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
		"baselineCharacteristics":"Baseline characteristics",
		"search":"Search cohorts"
	}
	
	$scope.cohorts = CohortUKPDSOM2.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.cohorts, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.cohorts, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.cohorts.forEach(function(cohort, idx) {
			if (cohort.selected) {
				var duplicateCohort = angular.copy(cohort);
				delete cohort.selected;

				delete duplicateCohort._id;
				delete duplicateCohort.selected;
				duplicateCohort.sharedWith = [];
				duplicateCohort.creationDate = new Date().getTime();
				duplicateCohort.name = duplicateCohort.name + " copy";
				duplicateCohort.clonedFrom = cohort._id;
				
				duplicateCohort.$save({}, function(data) {
					$scope.cohorts.push(duplicateCohort);
					if (options.modal) {
						$scope.editCohortModal('lg', duplicateCohort._id);
					} else {
						$location.path('/ukpdsom2/cohort/' + duplicateCohort._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.cohorts.forEach(function(cohort, idx) {
			if (cohort.selected) {
				cohort.$delete({}, function(data) {
					$scope.cohorts = $scope.cohorts.filter(function(cohort) {
						return cohort._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllersUKPDSOM2.controller("EditCohortUKPDSOM2", ["$scope", "$routeParams", "$location", "CohortUKPDSOM2",  function($scope, $routeParams, $location, CohortUKPDSOM2) {
	$scope.strings = {
		"title":"Cohort",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cohort = CohortUKPDSOM2.get({cohortId:$routeParams.id});
	$scope.backVisible = true;
  $scope.cohort.$promise.then(function(cohort) {
    $scope.readOnly = !cohort.owner;
  });
	
	$scope.ok = function () {
		$scope.cohort.$update({}, function(data) {
			$location.path('/ukpdsom2/cohorts');
		})
	};

	$scope.cancel = function () {
		$location.path('/ukpdsom2/cohorts');
	};
}]);

PRIMEControllersUKPDSOM2.controller("EditCohortModalUKPDSOM2", ["$scope", "$modalInstance", "$routeParams", "$location", "CohortUKPDSOM2", "cohortId", "cohorts", function($scope, $modalInstance, $routeParams, $location, CohortUKPDSOM2, cohortId, cohorts) {
	$scope.strings = {
		"title":"Cohort",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	
	if (cohorts !== null) {
		$scope.cohort = angular.copy(cohorts.filter(function(cohort){
			return cohort._id === cohortId;
		})[0]);
	} else {
		$scope.cohort = Cohort.get({cohortId:cohortId});
	}
	
	$scope.readOnly = !$scope.cohort.owner;

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cohort); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };

}]);

PRIMEControllersUKPDSOM2.controller("NewCohortUKPDSOM2", ["$scope", "$modalInstance", "CohortUKPDSOM2", "DefaultCohortUKPDSOM2", "DefaultCohorts", function ($scope, $modalInstance, CohortUKPDSOM2, DefaultCohortUKPDSOM2, DefaultCohorts) {
	$scope.strings = {
		"title":"New cohort",
		"createButton":"Create new cohort",
		"cancelButton":"Cancel"
	}
	$scope.create = true;
	$scope.cohort = new CohortUKPDSOM2(DefaultCohortUKPDSOM2);
	$scope.cohort.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { delete $scope.cohort._id; $modalInstance.close($scope.cohort); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);








// ===============================================
// Treatments
// ===============================================
PRIMEControllersUKPDSOM2.controller("TreatmentsUKPDSOM2", ["$scope", "$location", "$modal", "$controller", "TreatmentUKPDSOM2", function ($scope, $location, $modal, $controller, TreatmentUKPDSOM2) {

	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newTreatment = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/treatment-new.html?v=1.0.3",
			controller: "NewTreatmentUKPDSOM2",
			size: size,
			resolve: {
				treatments: function () {
					return $scope.treatments;
				}
			}
		});

		modalInstance.result.then(function (newTreatment) {
			newTreatment.$save({}, function(data) {
				$scope.treatments.push(newTreatment);
				console.log("New treatment created: ", newTreatment);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create treatment modal dismissed at: " + new Date());
		});
	}
	
	$scope.editTreatmentModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/ukpdsom2/treatment-new.html?v=1.0.3",
			controller: "EditTreatmentModalUKPDSOM2",
			size: size,
			resolve: {
				treatments: function () { return $scope.treatments; },
				treatmentId: function() { return id; }
			}
		});

		modalInstance.result.then(function (editedTreatment) {
			editedTreatment.$update({}, function(data) {
				$scope.treatments.filter(function(treatment, index, treatments) {
					if (treatment._id === data._id) {
						treatments[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit treatment modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"UKPDS OM2 Treatments",
		"search":"Search treatments",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}

	$scope.treatments = TreatmentUKPDSOM2.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.treatments, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.treatments, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.treatments.forEach(function(treatment, idx) {
			if (treatment.selected) {
				var duplicateTreatment = angular.copy(treatment);
				delete treatment.selected;

				delete duplicateTreatment._id;
				delete duplicateTreatment.selected;
				duplicateTreatment.sharedWith = [];
				duplicateTreatment.creationDate = new Date().getTime();
				duplicateTreatment.name = duplicateTreatment.name + " copy";
				duplicateTreatment.clonedFrom = treatment._id;
				
				duplicateTreatment.$save({}, function(data) {
					$scope.treatments.push(duplicateTreatment);
					if (options.modal) {
						$scope.editTreatmentModal('lg', duplicateTreatment._id);
					} else {
						$location.path('/ukpdsom2/treatment/' + duplicateTreatment._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.treatments.forEach(function(treatment, idx) {
			if (treatment.selected) {
				treatment.$delete({}, function(data) {
					$scope.treatments = $scope.treatments.filter(function(treatment) {
						return treatment._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllersUKPDSOM2.controller("NewTreatmentUKPDSOM2", ["$scope", "$rootScope", "$modalInstance", "TreatmentUKPDSOM2", "DefaultTreatmentUKPDSOM2", "DefaultTreatmentSwitchUKPDSOM2", "SwitchEvents", "SwitchRiskFactorsUKPDSOM2", function ($scope, $rootScope, $modalInstance, TreatmentUKPDSOM2, DefaultTreatmentUKPDSOM2, DefaultTreatmentSwitchUKPDSOM2, SwitchEvents, SwitchRiskFactors) {
	$scope.strings = {
		"title":"New treatment",
		"createButton":"Create new treatment",
		"cancelButton":"Cancel"
	};
	
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	
	$scope.switchEvents = SwitchEvents;
	$scope.switchRiskFactors = SwitchRiskFactors;
	
	$scope.switchEvent = "AMP";
	$scope.switchRiskFactor = "BMI";
	
	$scope.treatment = new TreatmentUKPDSOM2(DefaultTreatmentUKPDSOM2);
	$scope.treatment.creationDate = new Date().getTime();
	$scope.backVisible = false;

	$scope.removeSwitch = function(treatment) {
		if (treatment && treatment.switchCondition) {
			treatment.switchCondition = null;
		}
	};
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitchUKPDSOM2);
		deepestTreatment.switchCondition.subsequentTreatment.depth = deepestTreatment.depth + 1;
		
		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};
	
	$scope.ok = function () {
		$modalInstance.close($scope.treatment);
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};
}]);

PRIMEControllersUKPDSOM2.controller("EditTreatmentUKPDSOM2", ["$scope", "$rootScope", "$routeParams", "$location", "TreatmentUKPDSOM2", "DefaultTreatmentSwitchUKPDSOM2", "SwitchEvents", "SwitchRiskFactorsUKPDSOM2", function($scope, $rootScope, $routeParams, $location, TreatmentUKPDSOM2, DefaultTreatmentSwitchUKPDSOM2, SwitchEvents, SwitchRiskFactorsUKPDSOM2) {
	$scope.strings = {
		"title":"Treatment",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	};
	
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	
	$scope.switchEvents = SwitchEvents;
	$scope.switchRiskFactors = SwitchRiskFactorsUKPDSOM2;

	$scope.treatment = TreatmentUKPDSOM2.get({treatmentId:$routeParams.id});
	$scope.backVisible = true;
  $scope.treatment.$promise.then(function(treatment) {
    $scope.readOnly = !treatment.owner;
  });

	$scope.removeSwitch = function(treatment) {
		if (treatment && treatment.switchCondition) {
			treatment.switchCondition = null;
		}
	};
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitchUKPDSOM2);
		deepestTreatment.switchCondition.subsequentTreatment.depth = deepestTreatment.depth + 1;

		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};
	
	$scope.ok = function () {
		$scope.treatment.$update({}, function(data) {
			$location.path('/ukpdsom2/treatments');
		})
	};

	$scope.cancel = function () {
		$location.path('/ukpdsom2/treatments');
	};
}])

PRIMEControllersUKPDSOM2.controller("EditTreatmentModalUKPDSOM2", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "TreatmentUKPDSOM2", "DefaultTreatmentSwitchUKPDSOM2", "SwitchEvents", "SwitchRiskFactorsUKPDSOM2", "treatmentId", "treatments", function($scope, $rootScope, $modalInstance, $routeParams, $location, TreatmentUKPDSOM2, DefaultTreatmentSwitchUKPDSOM2, SwitchEvents, SwitchRiskFactors, treatmentId, treatments) {
	$scope.strings = {
		"title":"Treatment",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	};
	
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	
	$scope.switchEvents = SwitchEvents;
	$scope.switchRiskFactors = SwitchRiskFactors;
	
	if (treatments !== null) {
		$scope.treatment = angular.copy(treatments.filter(function(treatment){
			return treatment._id === treatmentId;
		})[0]);
	} else {
		$scope.treatment = TreatmentUKPDSOM2.get({treatmentId:treatmentId});
	}

	$scope.removeSwitch = function(treatment) {
		if (treatment && treatment.switchCondition) {
			treatment.switchCondition = null;
		}
	};
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitchUKPDSOM2);
		deepestTreatment.switchCondition.subsequentTreatment.depth = deepestTreatment.depth + 1;
	
		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo({left:"933px", top:50}, 500);
		});
	};

	$scope.readOnly = !$scope.treatment.owner;
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.treatment); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);






// ===============================================
// Costs
// ===============================================
PRIMEControllersUKPDSOM2.controller("CostsUKPDSOM2", ["$scope", "$location", "$modal", "$controller", "CostUKPDSOM2", function ($scope, $location, $modal, $controller, CostUKPDSOM2) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCost = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/cost-new.html",
			controller: "NewCostUKPDSOM2",
			size: size,
			resolve: {
				costs: function () {
					return $scope.costs;
				}
			}
		});

		modalInstance.result.then(function (newCost) {
			newCost.$save({}, function(data) {
				$scope.costs.push(newCost);
				console.log("New cost created: ", newCost);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create cost modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCostModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/ukpdsom2/cost-new.html",
			controller: "EditCostModalUKPDSOM2",
			size: size,
			resolve: {
				costs: function () { return $scope.costs; },
				costId: function() { return id; }
			}
		});

		modalInstance.result.then(function (editedCost) {
			editedCost.$update({}, function(data) {
				$scope.costs.filter(function(cost, index, costs) {
					if (cost._id === data._id) {
						costs[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit cost modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"UKPDS OM2 Costs",
		"search":"Search costs",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.costs = CostUKPDSOM2.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.costs, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.costs, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.costs.forEach(function(cost, idx) {
			if (cost.selected) {
				var duplicateCost = angular.copy(cost);
				delete cost.selected;

				delete duplicateCost._id;
				delete duplicateCost.selected;
				duplicateCost.creationDate = new Date().getTime();
				duplicateCost.name = duplicateCost.name + " copy";
				duplicateCost.clonedFrom = cost._id;
				
				duplicateCost.$save({}, function(data) {
					$scope.costs.push(duplicateCost);
					if (options.modal) {
						$scope.editCostModal('lg', duplicateCost._id);
					} else {
						$location.path('/ukpdsom2/cost/' + duplicateCost._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.costs.forEach(function(cost, idx) {
			if (cost.selected) {
				cost.$delete({}, function(data) {
					$scope.costs = $scope.costs.filter(function(cost) {
						return cost._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllersUKPDSOM2.controller("NewCostUKPDSOM2", ["$scope", "$modalInstance", "CostUKPDSOM2", "DefaultCostUKPDSOM2", function ($scope, $modalInstance, CostUKPDSOM2, DefaultCostUKPDSOM2) {
	
	$scope.strings = {
		"title":"New costs",
		"createButton":"Create new costs",
		"cancelButton":"Cancel"
	}
	
	$scope.cost = new CostUKPDSOM2(DefaultCostUKPDSOM2);
	$scope.cost.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cost); };
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllersUKPDSOM2.controller("EditCostUKPDSOM2", ["$scope", "$routeParams", "$location", "CostUKPDSOM2", function($scope, $routeParams, $location, CostUKPDSOM2) {
	$scope.strings = {
		"title":"Cost",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cost = CostUKPDSOM2.get({costId:$routeParams.id});
	$scope.backVisible = true;
  $scope.cost.$promise.then(function(cost) {
    $scope.readOnly = !cost.owner;
  });
	
	$scope.ok = function () {
		$scope.cost.$update({}, function(data) {
			$location.path('/ukpdsom2/costs');
		})
	};

	$scope.cancel = function () {
		$location.path('/ukpdsom2/costs');
	};
}])

PRIMEControllersUKPDSOM2.controller("EditCostModalUKPDSOM2", ["$scope", "$modalInstance", "$routeParams", "$location", "CostUKPDSOM2", "costId", "costs", function($scope, $modalInstance, $routeParams, $location, CostUKPDSOM2, costId, costs) {
	$scope.strings = {
		"title":"Cost",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	
	if (costs !== null) {
		$scope.cost = angular.copy(costs.filter(function(cost){
			return cost._id === costId;
		})[0]);	
	} else {
		$scope.cost = Cost.get({costId:costId});
	}
	
	$scope.readOnly = !$scope.cost.owner;
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cost); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);








// ===============================================
// Utilities
// ===============================================
PRIMEControllersUKPDSOM2.controller("UtilitiesUKPDSOM2", ["$scope", "$location", "$modal", "$controller", "UtilityUKPDSOM2", function ($scope, $location, $modal, $controller, UtilityUKPDSOM2) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newUtility = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/utility-new.html",
			controller: "NewUtilityUKPDSOM2",
			size: size,
			resolve: {
				utilities: function () {
					return $scope.utilities;
				}
			}
		});

		modalInstance.result.then(function (newUtility) {
			newUtility.$save({}, function(data) {
				$scope.utilities.push(newUtility);
				console.log("New utility created: ", newUtility);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create utility modal dismissed at: " + new Date());
		});
	}
	
	
	$scope.editUtilityModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/utility-new.html",
			controller: "EditUtilityModal",
			size: size,
			resolve: {
				utilities: function () { return $scope.utilities; },
				utilityId: function() { return id; },
				readOnly: function() { return false; }
			}
		});

		modalInstance.result.then(function (editedUtility) {
			editedUtility.$update({}, function(data) {
				$scope.utilities.filter(function(utility, index, utilities) {
					if (utility._id === data._id) {
						utilities[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit utility modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"UKPDS OM2 Utilities",
		"search":"Search utilities",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.utilities = UtilityUKPDSOM2.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.utilities, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.utilities, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.utilities.forEach(function(utility, idx) {
			if (utility.selected) {
				var duplicateUtility = angular.copy(utility);
				delete utility.selected;

				delete duplicateUtility._id;
				delete duplicateUtility.selected;
				duplicateUtility.creationDate = [];
				duplicateUtility.creationDate = new Date().getTime();
				duplicateUtility.name = duplicateUtility.name + " copy";
				duplicateUtility.clonedFrom = utility._id;
				
				duplicateUtility.$save({}, function(data) {
					$scope.utilities.push(duplicateUtility);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateUtility._id);
					} else {
						$location.path('/ukpdsom2/utility/' + duplicateUtility._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.utilities.forEach(function(utility, idx) {
			if (utility.selected) {
				utility.$delete({}, function(data) {
					$scope.utilities = $scope.utilities.filter(function(utility) {
						return utility._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllersUKPDSOM2.controller("NewUtilityUKPDSOM2", ["$scope", "$rootScope", "$modalInstance", "UtilityUKPDSOM2", "DefaultUtilityUKPDSOM2", function ($scope, $rootScope, $modalInstance, UtilityUKPDSOM2, DefaultUtilityUKPDSOM2) {
	
	$scope.strings = {
		"title":"New utility",
		"createButton":"Create new utility",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptions;
	
	$scope.utility = new UtilityUKPDSOM2(DefaultUtilityUKPDSOM2);
	$scope.utility.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.utility); };
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllersUKPDSOM2.controller("EditUtilityUKPDSOM2", ["$scope", "$rootScope", "$routeParams", "$location", "UtilityUKPDSOM2", function($scope, $rootScope, $routeParams, $location, UtilityUKPDSOM2) {
	$scope.strings = {
		"title":"Utility",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptions;
	$scope.utility = UtilityUKPDSOM2.get({utilityId:$routeParams.id});
	$scope.backVisible = true;
  $scope.utility.$promise.then(function(utility) {
    $scope.readOnly = !utility.owner;
  });
	
	$scope.ok = function () {
		$scope.utility.$update({}, function(data) {
			$location.path('/ukpdsom2/utilities');
		})
	};

	$scope.cancel = function () {
		$location.path('/ukpdsom2/utilities');
	};
}])

PRIMEControllersUKPDSOM2.controller("EditUtilityModalUKPDSOM2", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "UtilityUKPDSOM2", "utilityId", "utilities", function($scope, $rootScope, $modalInstance, $routeParams, $location, UtilityUKPDSOM2, utilityId, utilities) {
	$scope.strings = {
		"title":"Utility",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptions;
	
	if (utilities !== null) {
		$scope.utility = angular.copy(utilities.filter(function(utility){
			return utility._id === utilityId;
		})[0]);	
	} else {
		$scope.utility = UtilityUKPDSOM2.get({utilityId:utilityId});
	}

  $scope.utility.$promise.then(function(utility) {
    $scope.readOnly = !utility.owner;
  });
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.utility); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);












// ===============================================
// Countries
// ===============================================
PRIMEControllersUKPDSOM2.controller("CountriesUKPDSOM2", ["$scope", "$location", "$modal", "$controller", "CountryUKPDSOM2", function ($scope, $location, $modal, $controller, CountryUKPDSOM2) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCountry = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/country-new.html",
			controller: "NewCountryUKPDSOM2",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; },
			}
		});

		modalInstance.result.then(function (newCountry) {
			newCountry.$save({}, function(data) {
				$scope.countries.push(newCountry);
				console.log("New country created: ", newCountry);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create country modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCountryModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/ukpdsom2/country-new.html?v=1.0.10",
			controller: "EditCountryModalUKPDSOM2",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; },
				countryId: function() { return id; },
			}
		});

		modalInstance.result.then(function (editedCountry) {
			editedCountry.$update({}, function(data) {
				$scope.countries.filter(function(country, index, countries) {
					if (country._id === data._id) {
						countries[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
		});
	}
	
	
	$scope.strings = {
		"title":"UKPDS OM2 Countries",
		"search":"Search countries",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.countries = CountryUKPDSOM2.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.countries, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.countries, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				var duplicateCountry = angular.copy(country);
				delete country.selected;

				delete duplicateCountry._id;
				delete duplicateCountry.selected;
				duplicateCountry.sharedWith = [];
				duplicateCountry.creationDate = new Date().getTime();
				duplicateCountry.name = duplicateCountry.name + " copy";
				duplicateCountry.clonedFrom = country._id;
				
				duplicateCountry.$save({}, function(data) {
					$scope.countries.push(duplicateCountry);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateCountry._id);
					} else {
						$location.path('/ukpdsom2/country/' + duplicateCountry._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				country.$delete({}, function(data) {
					$scope.countries = $scope.countries.filter(function(country) {
						return country._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllersUKPDSOM2.controller("NewCountryUKPDSOM2", ["$scope", "$rootScope", "$modalInstance", "CountryUKPDSOM2", "DefaultCountryUKPDSOM2", "LifeTableUKPDSOM2", function ($scope, $rootScope, $modalInstance, CountryUKPDSOM2, DefaultCountryUKPDSOM2, LifeTableUKPDSOM2) {
	
	$scope.strings = {
		"title":"New country",
		"createButton":"Create new T2D country",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDModelAveragingOptions;
	
	$scope.lifetables = LifeTableUKPDSOM2.query();
	$scope.country = new CountryUKPDSOM2(DefaultCountryUKPDSOM2);
	$scope.country.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllersUKPDSOM2.controller("EditCountryUKPDSOM2", ["$scope", "$rootScope", "$routeParams", "$location", "CountryUKPDSOM2", "LifeTableUKPDSOM2", function($scope, $rootScope, $routeParams, $location, CountryUKPDSOM2, LifeTableUKPDSOM2) {
	$scope.strings = {
		"title":"Country",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDModelAveragingOptions;
	
	$scope.lifetables = LifeTableUKPDSOM2.query();
	$scope.country = CountryUKPDSOM2.get({countryId:$routeParams.id});
	$scope.backVisible = true;
  $scope.country.$promise.then(function(country) {
    $scope.readOnly = !country.owner;
  });
	
	$scope.ok = function () {
		$scope.country.$update({}, function(data) {
			$location.path('/ukpdsom2/countries');
		})
	};

	$scope.cancel = function () {
		$location.path('/ukpdsom2/countries');
	};
}])

PRIMEControllersUKPDSOM2.controller("EditCountryModalUKPDSOM2", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "CountryUKPDSOM2", "countryId", "countries", "LifeTableUKPDSOM2", function($scope, $rootScope, $modalInstance, $routeParams, $location, CountryUKPDSOM2, countryId, countries, LifeTableUKPDSOM2) {
	$scope.strings = {
		"title":"Country",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDModelAveragingOptions;
	
	$scope.lifetables = LifeTableUKPDSOM2.query();
	
	if (countries !== null) {
		$scope.country = angular.copy(countries.filter(function(country){
			return country._id === countryId;
		})[0]);		
	} else {
		$scope.country = CountryUKPDSOM2.get({countryId:countryId});
	}

  $scope.readOnly = !$scope.country.owner;

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);









// ===============================================
// Simulations
// ===============================================
PRIMEControllersUKPDSOM2.controller("SimulationsUKPDSOM2", ["$scope", "$window", "$routeParams", "$location", "$timeout", "SimulationServiceUKPDSOM2", "ICERCalculator", "Stats", "QueueServiceUKPDSOM2", function ($scope, $window, $routeParams, $location, $timeout, SimulationServiceUKPDSOM2, ICERCalculator, Stats, QueueServiceUKPDSOM2) {
	$scope.strings = {
		"title":"UKPDS OM2 Simulations",
		"searchSimulations":"Search simulations",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
		"export":"Export to Excel"
	}
  // UI state
  $scope.query     = "";     // bound to input
  $scope.page      = 1;
  $scope.pageSize  = 20;
  $scope.total     = 0;
  $scope.totalPages = 1;
  $scope.loading   = false;
  $scope.errorMsg  = null;

  // current page data
  $scope.paged = { items: [] }; // {items, page, pageSize, total, totalPages}

  $scope.icer = ICERCalculator.icer;

  $scope.newSimulation = function() { $location.path("/ukpdsom2/simulations/new"); };

  // queue polling (unchanged)
  $scope.queueLength = '';
  (function tick() {
    QueueServiceUKPDSOM2.get(function(model) {
      $scope.queueLength = model;
      $timeout(tick, 40000);
    });
  })();

  // ---- pagination + search ----
  let searchDebounce;
  $scope.loadPage = function(page, opts) {
    opts = opts || {};
    if (page) $scope.page = page;
    if ($scope.loading  && !opts.force) return;          // prevent double-click spam
    $scope.loading = true;
    $scope.errorMsg = null;

    const params = {
      page: $scope.page,
      pageSize: $scope.pageSize,
      search: $scope.query || undefined
    };

    // IMPORTANT: use $promise so we can .finally()
    SimulationServiceUKPDSOM2.queryPaged(params).$promise
      .then(function(res){
        (res.items || []).forEach(function(it){ it.selected = !!it.selected; });
        $scope.paged = res;
        $scope.total = res.total || 0;
        $scope.totalPages = res.totalPages || 1;
      })
      .catch(function(err){
        $scope.paged = { items: [] };
        $scope.total = 0;
        $scope.totalPages = 1;
        $scope.errorMsg = 'Failed to load simulations.';
        console.error(err);
      })
      .finally(function(){
        $scope.loading = false;
      });
  };

  // initial load
  $scope.loadPage(1);

  // debounce search input → restart from page 1
  $scope.$watch("query", function() {
    if (searchDebounce) $timeout.cancel(searchDebounce);
    searchDebounce = $timeout(function(){
      $scope.page = 1;
      $scope.loadPage(1);
    }, 300);
  });

  // selection helpers (work on current page)
  $scope.selectedItems = function() {
    var count = 0;
    angular.forEach($scope.paged.items, function(v){ if (v.selected) count++; });
    return count;
  };
  $scope.hasOwnership = function() {
    var owner = true;
    angular.forEach($scope.paged.items, function(v){ if (v.selected && !v.owner) owner = false; });
    return owner;
  };

  // actions
  $scope.cloneSelected = function() {
    $scope.paged.items.forEach(function(sim){ if (sim.selected) $location.path('/ukpdsom2/simulations/new/' + sim._id); });
  };
  $scope.deleteSelected = function () {
    if ($scope.loading) return;

    var ids = $scope.paged.items
      .filter(function (sim) { return sim.selected; })
      .map(function (sim) { return sim._id; });

    if (!ids.length) return;
    if (!$window.confirm('Delete ' + ids.length + ' simulation(s)?')) return;

    $scope.loading = true;
    var remaining = ids.length;

    var allSelectedOnPage = $scope.paged.items.every(function (it) { return it.selected; });
    var targetPage = (allSelectedOnPage && $scope.page > 1) ? ($scope.page - 1) : $scope.page;

    ids.forEach(function (id) {
      SimulationServiceUKPDSOM2.delete({ simulationId: id }).$promise
        .catch(function (err) { console.error('Delete failed for', id, err); })
        .finally(function () {
          if (--remaining === 0) $scope.loadPage(targetPage, { force: true });
        });
    });
  };
  $scope.exportSelected = function() {
    var ids = [];
    $scope.paged.items.forEach(function(sim){ if (sim.selected) ids.push(sim._id); });
    if (ids.length) $window.location.href = './api/ukpdsom2/simulations/batchexport/' + ids.join();
  };
}]);

PRIMEControllersUKPDSOM2.controller("SimulationUKPDSOM2", ["$scope", "$interval", "$window", "$rootScope", "$routeParams", "$location", "$modal", "SimulationServiceUKPDSOM2", "ICERCalculatorUKPDSOM2", "Stats", function ($scope, $interval, $window, $rootScope, $routeParams, $location, $modal, SimulationServiceT2D, ICERCalculatorUKPDSOM2, Stats) {
	$scope.strings = {
		"title":"Simulation",
		"clone":"Duplicate",
		"excelExport":"Export to Excel",
		"animate":"Animate",
		"stop":"Stop"
	}
	
	$scope.icer = ICERCalculatorUKPDSOM2.icer;
	
	$scope.clone = function() {
		$location.path('/ukpdsom2/simulations/new/' + $scope.results._id);
	}
	
	$scope.export = function() {
		$window.location.href = './api/ukpdsom2/simulations/' + $scope.results._id + '?excel=true';
	}
	
	$scope.scenario1Name = "Comparator";
	$scope.scenario2Name = "Intervention";
	
	$scope.animating = false;
	
	$scope.options = {
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					if (typeof tooltipItem.yLabel === "string") {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toFixed(2);
					} else {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(2);	
					}
				}
			}
		},
		legend: { 
			display: true
		},
		scales: {
			xAxes: [{
				ticks: {
					maxTicksLimit: 10,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				ticks: {
					min:0
				}
			}]
		},
		elements: {
			line: {
				fill: false
			}
		}
	};
	$scope.renalStackedOptions = {
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);
				}
			}
		},
		legend: { 
			display: true
		},
		scales: {
			xAxes: [{
				ticks: {
					maxTicksLimit: 10,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				stacked: true,
				ticks: {
					min:0
				}
			}]
		},
		elements: {
			line: {
				fill: true
			}
		}
	}
	$scope.cvdStackedOptions = angular.copy($scope.renalStackedOptions);
	$scope.cvdStackedOptions.scales.yAxes[0].stacked = false;
	$scope.cvdStackedOptions.elements.line.fill = false;
	
	$scope.costOptions = angular.copy($scope.renalStackedOptions);
	$scope.costOptions.scales.xAxes[0].stacked = true;
	$scope.costOptions.tooltips.callbacks.label = function(tooltipItem, data) {
		return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(0);
	}
	$scope.costOptions.scales.yAxes[0].stacked = true;
	
	$scope.qolOptions = angular.copy($scope.renalStackedOptions);
	delete $scope.qolOptions.scales.yAxes[0].ticks.min;
	
	$scope.simulations = SimulationServiceT2D.get({simulationId:$routeParams.id});
	
	$scope.show = function(size, id, elementType) {
		switch (elementType) {
		case "cohorts":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/ukpdsom2/cohort-new.html",
				controller: "EditCohortModalUKPDSOM2",
				size: size,
				resolve: {
					cohorts: function () { return null; },
					cohortId: function() { return id; },
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "treatments":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/ukpdsom2/treatment-new.html?v=1.0.3",
				controller: "EditTreatmentModalUKPDSOM2",
				size: size,
				resolve: {
					treatments: function () { return null; },
					treatmentId: function() { return id; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "costs":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/ukpdsom2/cost-new.html",
				controller: "EditCostModalUKPDSOM2",
				size: size,
				resolve: {
					costs: function () { return null; },
					costId: function() { return id; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "utilities":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/ukpdsom2/utility-new.html",
				controller: "EditUtilityModalUKPDSOM2",
				size: size,
				resolve: {
					utilities: function () { return null; },
					utilityId: function() { return id; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "countries":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/ukpdsom2/country-new.html?v=1.0.10",
				controller: "EditCountryModalUKPDSOM2",
				size: size,
				resolve: {
					countries: function () { return null; },
					countryId: function() { return id; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		}
	}
	
	$scope.simulations.$promise.then(function(data) {
		$scope.results = data;
		$scope.labels = [];
		for (var i = 0; i <= data.timeHorizon; i++) {
			$scope.labels.push(i);
		}
		for (element in $scope.results.fullElements) {
			$scope.results.fullElements[element].pluralize = $rootScope.plurals[element];
		}
		
		$scope.series = [$scope.scenario1Name, $scope.scenario2Name];
		
		$scope.survivalCurves = [data.arms['0'].survivalOverTime, data.arms['1'].survivalOverTime];
		$scope.hbA1cCurves = [data.arms['0'].meanHbA1cOverTime, data.arms['1'].meanHbA1cOverTime];
		$scope.sBPCurves = [data.arms['0'].meanSBPOverTime, data.arms['1'].meanSBPOverTime];
		$scope.bMICurves = [data.arms['0'].meanBMIOverTime, data.arms['1'].meanBMIOverTime];
		$scope.eGFRCurves = [data.arms['0'].meaneGFROverTime, data.arms['1'].meaneGFROverTime];
		$scope.ldlCholesterolCurves = [data.arms['0'].meanLDLOverTime, data.arms['1'].meanLDLOverTime];
		$scope.hdlCholesterolCurves = [data.arms['0'].meanHDLOverTime, data.arms['1'].meanHDLOverTime];
		$scope.severeHypoglycemia = [data.arms['0'].severeHypoRatesOverTime, data.arms['1'].severeHypoRatesOverTime];
		$scope.nonSevereHypoglycemia = [data.arms['0'].nonSevereDaytimeHypoRatesOverTime, data.arms['1'].nonSevereDaytimeHypoRatesOverTime];
		
		$scope.discountedCostBreakdown = true;
		($scope.recalcCostBreakdown = function() {
			if (data.arms['0'].costsOverTime !== undefined) {
			
				$scope.cvdCost = [0],
				$scope.renalCosts = [0],
				$scope.treatmentsCost = [0],
				$scope.adverseEventCost = [0],
				$scope.ocularCost = [0],
				$scope.neuropathyAmpCost = [0],
				$scope.cvdCost2 = [0],
				$scope.renalCosts2 = [0],
				$scope.treatmentsCost2 = [0],
				$scope.adverseEventCost2 = [0],
				$scope.ocularCost2 = [0],
				$scope.neuropathyAmpCost2 = [0],
				$scope.miCost1 = [0],
				$scope.strokeCost1 = [0],
				$scope.anginaCost1 = [0],
				$scope.chfCost1 = [0],
				$scope.retinopathyCost1 = [0],
				$scope.meCost1 = [0],
				$scope.neuropathyCost1 = [0],
				$scope.amputationCost1 = [0],
				$scope.ulcerCost1 = [0],
				$scope.renalCost1 = [0],
				$scope.hypoglycemiaCost1 = [0],
				$scope.treatmentCost1 = [0],
				$scope.concomitantCost1 = [0],
				$scope.miCost2 = [0],
				$scope.strokeCost2 = [0],
				$scope.anginaCost2 = [0],
				$scope.chfCost2 = [0],
				$scope.retinopathyCost2 = [0],
				$scope.meCost2 = [0],
				$scope.neuropathyCost2 = [0],
				$scope.amputationCost2 = [0],
				$scope.ulcerCost2 = [0],
				$scope.renalCost2 = [0],
				$scope.hypoglycemiaCost2 = [0],
				$scope.treatmentCost2 = [0],
				$scope.concomitantCost2 = [0];
			
				var disc1 = $scope.discountedCostBreakdown ? (1 + data.fullElements.countries[0].costDiscountRate / 100) : 1,
					disc2 = $scope.discountedCostBreakdown ? (data.fullElements.countries.length > 1 ? (1 + data.fullElements.countries[1].costDiscountRate / 100) : (1 + data.fullElements.countries[0].costDiscountRate / 100)) : 1;
				
				Object.keys(data.arms['0'].costsOverTime).forEach(function(key) {
					Object.keys(data.arms['0'].costsOverTime[key].stateProportionMap).forEach(function(costCategory) {
						switch (costCategory) {
							case "AMP":
								$scope.neuropathyAmpCost.push($scope.neuropathyAmpCost[$scope.neuropathyAmpCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['NEURO'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyAmpCost2.push($scope.neuropathyAmpCost2[$scope.neuropathyAmpCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['NEURO'] * 1 / Math.pow(disc2, parseInt(key) - 1));
							
								$scope.amputationCost1.push($scope.amputationCost1[$scope.amputationCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.amputationCost2.push($scope.amputationCost2[$scope.amputationCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "IHD":
								$scope.cvdCost.push($scope.cvdCost[$scope.cvdCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['CHF'] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['MI'] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['STROKE'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.cvdCost2.push($scope.cvdCost2[$scope.cvdCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['CHF'] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['MI'] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['STROKE'] * 1 / Math.pow(disc2, parseInt(key) - 1))
							
								$scope.anginaCost1.push($scope.anginaCost1[$scope.anginaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.anginaCost2.push($scope.anginaCost2[$scope.anginaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CHF":
								$scope.chfCost1.push($scope.chfCost1[$scope.chfCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.chfCost2.push($scope.chfCost2[$scope.chfCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "HYPO":
								$scope.hypoglycemiaCost1.push($scope.hypoglycemiaCost1[$scope.hypoglycemiaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.hypoglycemiaCost2.push($scope.hypoglycemiaCost2[$scope.hypoglycemiaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "MI":
								$scope.miCost1.push($scope.miCost1[$scope.miCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.miCost2.push($scope.miCost2[$scope.miCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RENAL":
								$scope.renalCosts.push($scope.renalCosts[$scope.renalCosts.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalCosts2.push($scope.renalCosts2[$scope.renalCosts2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								$scope.renalCost1.push($scope.renalCost1[$scope.renalCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalCost2.push($scope.renalCost2[$scope.renalCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "NEURO":
								$scope.neuropathyCost1.push($scope.neuropathyCost1[$scope.neuropathyCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyCost2.push($scope.neuropathyCost2[$scope.neuropathyCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "SVL":
								$scope.retinopathyCost1.push($scope.retinopathyCost1[$scope.retinopathyCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.retinopathyCost2.push($scope.retinopathyCost2[$scope.retinopathyCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ME":
								$scope.meCost1.push($scope.meCost1[$scope.meCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.meCost2.push($scope.meCost2[$scope.meCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ULCER":
								$scope.ulcerCost1.push($scope.ulcerCost1[$scope.ulcerCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.ulcerCost2.push($scope.ulcerCost2[$scope.ulcerCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RX":
								$scope.treatmentCost1.push($scope.treatmentCost1[$scope.treatmentCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.treatmentCost2.push($scope.treatmentCost2[$scope.treatmentCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "STROKE":
								$scope.strokeCost1.push($scope.strokeCost1[$scope.strokeCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.strokeCost2.push($scope.strokeCost2[$scope.strokeCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
						}
					})
				});
			
				$scope.costSeries = [ "Cardiovascular disease", "Renal", "Treatment", "Adverse events", "Blindness", "Neuropathy and amputation"];
			
				$scope.costCurve1 = [ $scope.cvdCost, $scope.renalCost1, $scope.treatmentCost1, $scope.hypoglycemiaCost1, $scope.retinopathyCost1, $scope.neuropathyAmpCost ];
				$scope.costCurve2 = [ $scope.cvdCost2, $scope.renalCost2, $scope.treatmentCost2, $scope.hypoglycemiaCost2, $scope.retinopathyCost2, $scope.neuropathyAmpCost2 ];
			}
		})();
		
		

		$scope.discountedQoLBreakdown = true;
		($scope.recalcQoLBreakdown = function() {
			if (data.arms['0'].qolOverTime !== undefined) {
			
				$scope.cvdQoL = [0],
				$scope.renalQoLs = [0],
				$scope.treatmentsQoL = [0],
				$scope.adverseEventQoL = [0],
				$scope.ocularQoL = [0],
				$scope.neuropathyAmpQoL = [0],
				$scope.cvdQoL2 = [0],
				$scope.renalQoLs2 = [0],
				$scope.treatmentsQoL2 = [0],
				$scope.adverseEventQoL2 = [0],
				$scope.ocularQoL2 = [0],
				$scope.neuropathyAmpQoL2 = [0];
		
				$scope.miQoL1 = [0],
				$scope.strokeQoL1 = [0],
				$scope.anginaQoL1 = [0],
				$scope.chfQoL1 = [0],
				$scope.retinopathyQoL1 = [0],
				$scope.neuropathyQoL1 = [0],
				$scope.amputationQoL1 = [0],
				$scope.renalQoL1 = [0],
				$scope.hypoglycemiaQoL1 = [0],
				$scope.treatmentQoL1 = [0],
				$scope.miQoL2 = [0],
				$scope.strokeQoL2 = [0],
				$scope.anginaQoL2 = [0],
				$scope.chfQoL2 = [0],
				$scope.retinopathyQoL2 = [0],
				$scope.neuropathyQoL2 = [0],
				$scope.amputationQoL2 = [0],
				$scope.renalQoL2 = [0],
				$scope.hypoglycemiaQoL2 = [0],
				$scope.treatmentQoL2 = [0];
			
				var disc1 = $scope.discountedQoLBreakdown ? (1 + data.fullElements.countries[0].effectDiscountRate / 100) : 1,
					disc2 = $scope.discountedQoLBreakdown ? (data.fullElements.countries.length > 1 ? (1 + data.fullElements.countries[1].effectDiscountRate / 100) : (1 + data.fullElements.countries[0].effectDiscountRate / 100)) : 1;
				
				Object.keys(data.arms['0'].qolOverTime).forEach(function(key) {
					Object.keys(data.arms['0'].qolOverTime[key].stateProportionMap).forEach(function(qolCategory) {
						switch (qolCategory) {
							case "AMP":
								$scope.neuropathyAmpQoL.push($scope.neuropathyAmpQoL[$scope.neuropathyAmpQoL.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['NEURO'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyAmpQoL2.push($scope.neuropathyAmpQoL2[$scope.neuropathyAmpQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['NEURO'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
							
								$scope.amputationQoL1.push($scope.amputationQoL1[$scope.amputationQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.amputationQoL2.push($scope.amputationQoL2[$scope.amputationQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "IHD":
								$scope.cvdQoL.push($scope.cvdQoL[$scope.cvdQoL.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['CHF'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['MI'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['STROKE'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.cvdQoL2.push($scope.cvdQoL2[$scope.cvdQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['CHF'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['MI'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['STROKE'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1))
							
								$scope.anginaQoL1.push($scope.anginaQoL1[$scope.anginaQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.anginaQoL2.push($scope.anginaQoL2[$scope.anginaQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CHF":
								$scope.chfQoL1.push($scope.chfQoL1[$scope.chfQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.chfQoL2.push($scope.chfQoL2[$scope.chfQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "HYPO":
								$scope.hypoglycemiaQoL1.push($scope.hypoglycemiaQoL1[$scope.hypoglycemiaQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.hypoglycemiaQoL2.push($scope.hypoglycemiaQoL2[$scope.hypoglycemiaQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "MI":
								$scope.miQoL1.push($scope.miQoL1[$scope.miQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.miQoL2.push($scope.miQoL2[$scope.miQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RENAL":
								$scope.renalQoLs.push($scope.renalQoLs[$scope.renalQoLs.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalQoLs2.push($scope.renalQoLs2[$scope.renalQoLs2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								$scope.renalQoL1.push($scope.renalQoL1[$scope.renalQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalQoL2.push($scope.renalQoL2[$scope.renalQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "NEURO":
								$scope.neuropathyQoL1.push($scope.neuropathyQoL1[$scope.neuropathyQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyQoL2.push($scope.neuropathyQoL2[$scope.neuropathyQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "SVL":
								$scope.retinopathyQoL1.push($scope.retinopathyQoL1[$scope.retinopathyQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.retinopathyQoL2.push($scope.retinopathyQoL2[$scope.retinopathyQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RX":					
								$scope.treatmentQoL1.push($scope.treatmentQoL1[$scope.treatmentQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.treatmentQoL2.push($scope.treatmentQoL2[$scope.treatmentQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "STROKE":
								$scope.strokeQoL1.push($scope.strokeQoL1[$scope.strokeQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.strokeQoL2.push($scope.strokeQoL2[$scope.strokeQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
						}
					})
				});
			
				$scope.qolSeries = [ "Cardiovascular disease", "Renal", "Treatment", "Adverse events", "Blindness", "Neuropathy and amputation"];
			
				$scope.qolCurve1 = [ $scope.cvdQoL, $scope.renalQoL1, $scope.treatmentQoL1, $scope.hypoglycemiaQoL1, $scope.retinopathyQoL1, $scope.neuropathyAmpQoL ];
				$scope.qolCurve2 = [ $scope.cvdQoL2, $scope.renalQoL2, $scope.treatmentQoL2, $scope.hypoglycemiaQoL2, $scope.retinopathyQoL2, $scope.neuropathyAmpQoL2 ];
			}
		})();
		
		
		
		
		$scope.complicationColors = [ '#4D5360', '#888888', '#803690', '#00ADF9', '#52996b', '#46BFBD', '#FDB45C' ];
		
		$scope.complicationCumulativeIncidenceLabels = ["Myocardial infarction", "Stroke", "Ischemic heart disease", "Heart failure", "Renal failure", "Amputation", "Blindness", "Ulcer"];
		
		$scope.complicationCumulativeIncidenceOptions = angular.copy($scope.options);
		$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].scaleLabel.labelString = "Cumulative incidence";
		$scope.complicationCumulativeIncidenceOptions.aspectRatio = 1.25;
		$scope.complicationCumulativeIncidenceOptions.tooltips.callbacks.label =  function(tooltipItem, data) {
					if (typeof tooltipItem.yLabel === "string") {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toFixed(3);
					} else {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);	
					}
				};
		
	
		$scope.animateComplicationIncidence = function() {
			if ($scope.animating) {
				$scope.animating = !$scope.animating;
				$interval.cancel($scope.cumulativeIncidenceAnimation);
				
				$scope.complicationCumulativeIncidence = [
					[
						data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[data.arms['0'].cumulativeIncidenceFirstStrokeOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceHeartFailureOverTime[data.arms['0'].cumulativeIncidenceHeartFailureOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceRenalFailureOverTime[data.arms['0'].cumulativeIncidenceRenalFailureOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceFirstAmputationOverTime[data.arms['0'].cumulativeIncidenceFirstAmputationOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceBlindnessOverTime[data.arms['0'].cumulativeIncidenceBlindnessOverTime.length - 1],
						data.arms['0'].cumulativeIncidenceUlcerOverTime[data.arms['0'].cumulativeIncidenceUlcerOverTime.length - 1]
					],
					[
						data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceFirstStrokeOverTime[data.arms['1'].cumulativeIncidenceFirstStrokeOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceHeartFailureOverTime[data.arms['1'].cumulativeIncidenceHeartFailureOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceRenalFailureOverTime[data.arms['1'].cumulativeIncidenceRenalFailureOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceFirstAmputationOverTime[data.arms['1'].cumulativeIncidenceFirstAmputationOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceBlindnessOverTime[data.arms['1'].cumulativeIncidenceBlindnessOverTime.length - 1],
						data.arms['1'].cumulativeIncidenceUlcerOverTime[data.arms['1'].cumulativeIncidenceUlcerOverTime.length - 1]
					]
				];
			} else {
				$scope.animating = !$scope.animating;
				$scope.animationProgress = 0;
				$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].ticks.min = 0;
				$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].ticks.max = 1;
				$scope.complicationCumulativeIncidence = [
					[0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
					[0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]
				];
			
				$scope.cumulativeIncidenceAnimation = $interval(function() { 
					$scope.complicationCumulativeIncidence = [
						[
							data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceHeartFailureOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceRenalFailureOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceFirstAmputationOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceBlindnessOverTime[$scope.animationProgress],
							data.arms['0'].cumulativeIncidenceUlcerOverTime[$scope.animationProgress]
						],
						[
							data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceFirstStrokeOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceHeartFailureOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceRenalFailureOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceFirstAmputationOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceBlindnessOverTime[$scope.animationProgress],
							data.arms['1'].cumulativeIncidenceUlcerOverTime[$scope.animationProgress]
						]
					];
					if ($scope.animationProgress >= data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1) {
						$scope.animationProgress = 0;
					} else {
						$scope.animationProgress++;
					}
				}, 200);	
			}
		}
		
		$scope.complicationCumulativeIncidence = [
			[
				data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[data.arms['0'].cumulativeIncidenceFirstStrokeOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceHeartFailureOverTime[data.arms['0'].cumulativeIncidenceHeartFailureOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceRenalFailureOverTime[data.arms['0'].cumulativeIncidenceRenalFailureOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceFirstAmputationOverTime[data.arms['0'].cumulativeIncidenceFirstAmputationOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceBlindnessOverTime[data.arms['0'].cumulativeIncidenceBlindnessOverTime.length - 1],
				data.arms['0'].cumulativeIncidenceUlcerOverTime[data.arms['0'].cumulativeIncidenceUlcerOverTime.length - 1]
			],
			[
				data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceFirstStrokeOverTime[data.arms['1'].cumulativeIncidenceFirstStrokeOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceHeartFailureOverTime[data.arms['1'].cumulativeIncidenceHeartFailureOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceRenalFailureOverTime[data.arms['1'].cumulativeIncidenceRenalFailureOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceFirstAmputationOverTime[data.arms['1'].cumulativeIncidenceFirstAmputationOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceBlindnessOverTime[data.arms['1'].cumulativeIncidenceBlindnessOverTime.length - 1],
				data.arms['1'].cumulativeIncidenceUlcerOverTime[data.arms['1'].cumulativeIncidenceUlcerOverTime.length - 1]
			]
		]; 
		
		$scope.cvdSeries = ["Myocardial infarction", "Stroke", "Ischemic heart disease"];
		
		($scope.rescaleCVD = function() {
			$scope.cvdStackedOptions.elements.line.fill = $scope.cvdStackedOptions.scales.yAxes['0'].stacked;
			
			var allValues = [];
			if ($scope.cvdStackedOptions.scales.yAxes[0].stacked) {
				data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.forEach(function(val, i, arr) {
					allValues.push(val + data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[i] + data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[i]);
				});	
			} else {
				allValues = data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime
					.concat(data.arms['0'].cumulativeIncidenceFirstStrokeOverTime)
					.concat(data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime)
					.concat(data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime)
					.concat(data.arms['1'].cumulativeIncidenceFirstStrokeOverTime)
					.concat(data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime);
			}
		
			$scope.cvdStackedOptions.scales.yAxes[0].ticks.suggestedMax = allValues.reduce(function(a, b) {
				return Math.max(a, b);
			}) * 1.05;	
		})();
		
		$scope.cvdCurve1 = [data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime, data.arms['0'].cumulativeIncidenceFirstStrokeOverTime, data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime];
		$scope.cvdCurve2 = [data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime, data.arms['1'].cumulativeIncidenceFirstStrokeOverTime, data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime];
		
		$scope.nephropathySeries = ["Renal failure"];
		$scope.nephropathyCurve1 = [data.arms['0'].cumulativeIncidenceRenalFailureOverTime];
		$scope.nephropathyCurve2 = [data.arms['1'].cumulativeIncidenceRenalFailureOverTime];
		
		$scope.neuropathySeries = ["Amputation", "Ulcer"]
		$scope.neuropathyCurve1 = [
			data.arms['0'].cumulativeIncidenceFirstAmputationOverTime, 
			data.arms['0'].cumulativeIncidenceUlcerOverTime
		];
		$scope.neuropathyCurve2 = [
			data.arms['1'].cumulativeIncidenceFirstAmputationOverTime,
			data.arms['1'].cumulativeIncidenceUlcerOverTime
		];
		
		$scope.blindnessSeries = ["Blindness"];
		$scope.blindnessCurve1 = [data.arms['0'].cumulativeIncidenceBlindnessOverTime];
		$scope.blindnessCurve2 = [data.arms['1'].cumulativeIncidenceBlindnessOverTime];
		
		
		if (data.psa) {
			$scope.scatterOptions = {
				type: 'scatter',
				animation: false,
				tooltips: {
					callbacks: {
						title: function(tooltipItem, tooltipData) {
							return '';
						},
						label: function(tooltipItem, tooltipData) {
							return (tooltipItem.xLabel.toFixed(3) > 0 ? "+" : "") + tooltipItem.xLabel.toFixed(3) + " QALYs   " + 
							tooltipItem.yLabel.toFixed(2) + " " + data.fullElements.costs[0].currency;	
						}
					}
				},
				showLines : false,
				scales: {
					yAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Incremental cost' + (data.fullElements.costs[0].currency !== undefined ? " (" + data.fullElements.costs[0].currency + ")" : "")
						}
					}],
					xAxes: [{
						type: 'linear',
						position: 'bottom',
						scaleLabel: {
							display: true,
							labelString: 'Incremental quality-adjusted life expectancy (QALYs)'
						}
						/*ticks: {
							max:0
						}*/
					}]
				}
			}
			$scope.psa = [];
			$scope.psaDiffs = {};
			$scope.psaDiffs.qale = [];
			$scope.psaDiffs.le = [];
			$scope.psaDiffs.cost = [];
			
			$scope.psaConfidenceIntervals = {};
			$scope.psaConfidenceIntervals.icerSum = 0;
			$scope.psaConfidenceIntervals.arm0 = {};
			$scope.psaConfidenceIntervals.arm0.qale95CILB = 0;
			$scope.psaConfidenceIntervals.arm0.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.arm0.cost95CILB = 0;
			$scope.psaConfidenceIntervals.arm0.cost95CIUB = 0;
			
			$scope.psaConfidenceIntervals.arm1 = {};
			$scope.psaConfidenceIntervals.arm1.qale95CILB = 0;
			$scope.psaConfidenceIntervals.arm1.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.arm1.cost95CILB = 0;
			$scope.psaConfidenceIntervals.arm1.cost95CIUB = 0;
			
			$scope.psaConfidenceIntervals.diff = {};
			$scope.psaConfidenceIntervals.diff.qale95CILB = 0;
			$scope.psaConfidenceIntervals.diff.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.diff.cost95CILB = 0;
			$scope.psaConfidenceIntervals.diff.cost95CIUB = 0;
			
			for (var i = 0; i < data.arms['0'].psaResults.length; i++) {
				$scope.psa.push({
					x: (data.arms['1'].psaResults[i].qale - data.arms['0'].psaResults[i].qale),
					y: (data.arms['1'].psaResults[i].cost - data.arms['0'].psaResults[i].cost)
				});
				$scope.psaDiffs.qale.push(data.arms['1'].psaResults[i].qale - data.arms['0'].psaResults[i].qale);
				$scope.psaDiffs.le.push(data.arms['1'].psaResults[i].le - data.arms['0'].psaResults[i].le);
				$scope.psaDiffs.cost.push(data.arms['1'].psaResults[i].cost - data.arms['0'].psaResults[i].cost);
			}
			
			$scope.psaConfidenceIntervals.arm0.qale95CILB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.qale; })) - Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.qale; }));
			$scope.psaConfidenceIntervals.arm0.qale95CIUB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.qale; })) + Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.qale; }));
			
			$scope.psaConfidenceIntervals.arm0.le95CILB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.le; })) - Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.le; }));
			$scope.psaConfidenceIntervals.arm0.le95CIUB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.le; })) + Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.le; }));
			
			$scope.psaConfidenceIntervals.arm0.cost95CILB = (Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.cost; })) - Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.cost; })));
			$scope.psaConfidenceIntervals.arm0.cost95CIUB = (Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.cost; })) + Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.cost; })));
			
			
			
			$scope.psaConfidenceIntervals.arm1.qale95CILB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.qale; })) - Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.qale; }));
			$scope.psaConfidenceIntervals.arm1.qale95CIUB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.qale; })) + Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.qale; }));
			
			$scope.psaConfidenceIntervals.arm1.le95CILB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.le; })) - Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.le; }));
			$scope.psaConfidenceIntervals.arm1.le95CIUB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.le; })) + Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.le; }));
			
			$scope.psaConfidenceIntervals.arm1.cost95CILB = (Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.cost; })) - Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.cost; })));
			$scope.psaConfidenceIntervals.arm1.cost95CIUB = (Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.cost; })) + Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.cost; })));
			
			$scope.psaConfidenceIntervals.diff.qale95CILB = Stats.mean($scope.psaDiffs.qale) - Stats.sd($scope.psaDiffs.qale);
			$scope.psaConfidenceIntervals.diff.qale95CIUB = Stats.mean($scope.psaDiffs.qale) + Stats.sd($scope.psaDiffs.qale);
			
			$scope.psaConfidenceIntervals.diff.le95CILB = Stats.mean($scope.psaDiffs.le) - Stats.sd($scope.psaDiffs.le);
			$scope.psaConfidenceIntervals.diff.le95CIUB = Stats.mean($scope.psaDiffs.le) + Stats.sd($scope.psaDiffs.le);
			$scope.psaConfidenceIntervals.diff.cost95CILB = (Stats.mean($scope.psaDiffs.cost) - Stats.sd($scope.psaDiffs.cost));
			$scope.psaConfidenceIntervals.diff.cost95CIUB = (Stats.mean($scope.psaDiffs.cost) + Stats.sd($scope.psaDiffs.cost));
			$scope.maxWTP = 10000;
			($scope.recalcCEAC = function() {
				$scope.ceac = [];
				$scope.ceacLabels = [];
				for (var i = 0; i <= 100; i++) {
					var wtp = i * ($scope.maxWTP/100);
					$scope.ceac.push($scope.psa.reduce(function(acc, val, i, arr) {
						if (val.x > 0 && val.y < 0) { // SE quadrant - count all
							++acc;
						}
						if (val.x > 0 && val.y > 0 && val.y/val.x < wtp) { // NE quadrant - count < WTP
							++acc;
						}
						if (val.x < 0 && val.y < 0 && val.y/val.x > wtp) { // SW quadrant - count > WTP
							++acc
						}
						return acc;
					}, 0)/$scope.psa.length * 100);
					$scope.ceacLabels.push(wtp);
				};
			})();
			$scope.ceacOptions = angular.copy($scope.options);
			$scope.ceacOptions.scales.xAxes[0].scaleLabel.labelString = "Willingness-to-pay threshold" + (data.fullElements.costs[0].currency !== undefined ? " (" + data.fullElements.costs[0].currency + " per QALY gained)" : "");
			$scope.ceacOptions.scales.yAxes[0].scaleLabel = {};
			$scope.ceacOptions.scales.yAxes[0].scaleLabel.labelString = "Likelihood of intervention being cost-effective (%)";
			$scope.ceacOptions.scales.yAxes[0].scaleLabel.display = true;
			$scope.ceacOptions.scales.yAxes[0].ticks.max = 100;
			$scope.ceacOptions.legend.display = false;
			$scope.ceacOptions.aspectRatio = 1.8;
			$scope.ceacOptions.tooltips.callbacks.label = function(tooltipItem, data) {
				return tooltipItem.yLabel.toFixed(1) + "%";
			}
		}
	});

}]);

PRIMEControllersUKPDSOM2.controller("NewSimulationUKPDSOM2", ["$scope", "$rootScope", "$routeParams", "$location", "SimulationServiceUKPDSOM2", function ($scope, $rootScope, $routeParams, $location, SimulationServiceUKPDSOM2) {
	$scope.strings = {
		"title":"New Simulation"
	}
	
	if ($routeParams.id !== undefined) {
		$scope.simulation = SimulationServiceUKPDSOM2.clone({simulationId:$routeParams.id});
		$scope.simulation.$promise.then(function(simulation) {
			delete simulation._id;
			simulation.name = simulation.name + " copy";
			simulation.sharedWith = [];
			simulation.creationDate = new Date().getTime();
		})

	} else {
		$scope.simulation = {
			name: "Simulation",
			patients: 500000,
			timeHorizon: 50,
			notes : "",
			creationDate: new Date().getTime(),
			psa: false,
			sampleTreatmentEffects: false,
			elements: {cohortIDs:[],
				treatmentIDs:[],
				costIDs:[],
				utilityIDs:[],
				countryIDs:[]
			},
			arms: {}
		};
	}

	
	$scope.runSimulation = function() {
		$scope.simulation["progress"] = "Waiting";
		
		SimulationServiceUKPDSOM2.save($scope.simulation, function() { });
		
		$location.path("/ukpdsom2/simulations/")
	}
}]);